/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReservationDetails {
    getFixupPrototypeFunction() { return ReservationDetails.fixupPrototype; }

    static newInstance(model: Partial<ReservationDetails>): ReservationDetails {
        let obj = Object.assign(new ReservationDetails(), model);
        ReservationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReservationDetails>): ReservationDetails {
        if (!model) return null;
        return ReservationDetails.newInstance(<ReservationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReservationDetails) {
        if (!obj) return;

        models.ReservationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReservationDetails): boolean {
        Object.setPrototypeOf(obj, ReservationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Reservation Id
     */
    reservation_id: string;

    /**
     * What is the payment option
     */
    payment_option: string;

    /**
     * RI hours being used
     */
    ri_hours_used: string;

    /**
     * Date of expiry
     */
    expiry_date: string;

    /**
     * Reservation SKU Details
     */
    reservation_sku: string;

    /**
     * Region
     */
    region: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

    /**
     * Cloud Account Id
     */
    cloud_account_id: string;

    /**
     * Utilization by percentage
     */
    utilization_percentage: string;

}
